export function weatherCodeToLabelPl(code) {
    if (code === 0) return 'Bezchmurnie';
    if (code === 1) return 'Pogodnie';
    if (code === 2) return 'Częściowo zachmurzono';
    if (code === 3) return 'Pochmurno';
    if (code === 45 || code === 48) return 'Mgła';
    if (code >= 51 && code <= 57) return 'Mżawka';
    if (code >= 61 && code <= 67) return 'Deszcz';
    if (code >= 71 && code <= 77) return 'Śnieg';
    if (code >= 80 && code <= 82) return 'Przelotne opady';
    if (code === 85 || code === 86) return 'Opady śniegu';
    if (code >= 95 && code <= 99) return 'Burza';
    return 'Zachmurzono';
}

export function windDirectionToLabel(deg) {
    if (deg == null || Number.isNaN(deg)) return '—';
    const dirs = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
    const i = Math.round(((deg % 360) / 22.5)) % 16;
    return dirs[i];
}
